declare global {
    interface Navigator {
        standalone?: boolean
    }
}

const PWA_SESSION_KEY = 'pwa_launch'

const getStandaloneMatch = (): boolean => {
    if (
        typeof window === 'undefined' ||
        typeof window.matchMedia !== 'function'
    ) {
        return false
    }

    return window.matchMedia('(display-mode: standalone)').matches
}

const getNavigatorStandalone = (): boolean => {
    if (typeof window === 'undefined') return false

    return window.navigator.standalone === true
}

const getAndroidAppReferrer = (): boolean => {
    if (typeof document === 'undefined') return false

    return document.referrer.includes('android-app://')
}

const setPwaLaunchSession = (): void => {
    try {
        sessionStorage.setItem(PWA_SESSION_KEY, 'true')
    } catch {
        // Ignore storage errors
    }
}

const getPwaLaunchSession = (): boolean => {
    try {
        return sessionStorage.getItem(PWA_SESSION_KEY) === 'true'
    } catch {
        return false
    }
}

export const detectPwaLaunch = (): boolean => {
    const isStandalone = getStandaloneMatch() || getNavigatorStandalone()
    const isAndroidAppReferrer = getAndroidAppReferrer()

    if (isStandalone || isAndroidAppReferrer) {
        setPwaLaunchSession()
        return true
    }

    return getPwaLaunchSession()
}

export const getDeviceHeaderValue = (): string | undefined => {
    if (typeof window === 'undefined') return undefined

    if (detectPwaLaunch()) {
        return 'Pwa'
    }

    return 'Web'
}
